import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Conferma Indirizzo Email',
  [OnboardingStep.BusinessInfo]: 'Aggiungi i dettagli del negozio',
  [OnboardingStep.PersonalInfo]: 'Aggiungi le tue informazioni personali',
  [OnboardingStep.ShippingInfo]: 'Aggiungi le informazioni di consegna',
  [OnboardingStep.BankInfo]: 'Aggiungi coordinate bancarie per i pagamenti',
  [OnboardingStep.TaxInfo]: 'La tua azienda è registrata ai fini IVA?',
  [OnboardingStep.BusinessDocs]: 'Documento di prova aziendale',
  [OnboardingStep.PersonalDocs]: "Documento di prova d'identità",
  [OnboardingStep.InfoSubmission]: 'Ricevi pagamenti',
  confirm_info_gateway: 'Ricevi pagamenti – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Informazioni di pagamento',
  [OnboardingStep.Subscription]: 'Abbonamento',
  [OnboardingStep.MobileApp]: 'App mobile',
  [OnboardingStep.DeliveryStructure]: 'Struttura di consegna',
  [OnboardingStep.Contract]: 'Contratto',
  [OnboardingStep.ContractPayment]: 'Pagamento contratto',
  [OnboardingStep.PromoCode]: 'Codice promo',
};
